import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../../interfaces/user';
import { AuthService } from '../../services/auth/auth.service';
import { FunctionsService } from '../../services/functions/functions.service';
import { ProfileService } from '../../services/profile/profile.service';
import { ActivatedRoute } from '@angular/router';
import { subscriptions } from 'stripe';
import { TestResultService } from '../../services/test-result/test-result.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, OnDestroy {
  public user$: Observable<User | null | undefined>;
  public showChangePassword$: Observable<boolean>;
  public shareUrl$: Observable<string>;
  public shareUrlCopied = false;
  public invitations$: Observable<{} | null>;
  public content: Entry<any>;
  public subscription: subscriptions.ISubscription | undefined;
  public hasSubscription: boolean | undefined;
  public testResult$: Observable<any>;
  // Delete us
  private classToToggle = 'navigation-invert';
  private classElement: HTMLElement;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private fnService: FunctionsService,
    private authService: AuthService,
    profileService: ProfileService,
    testResultService: TestResultService,
    route: ActivatedRoute,
  ) {
    this.content = route.snapshot.data.content;
    this.user$ = profileService.user();
    this.testResult$ = testResultService.getTestResult();
    this.invitations$ = profileService.userInvitations();
    this.showChangePassword$ = this.authService.hasPassword();
    this.shareUrl$ = this.getShareUrl();
    profileService.userActiveSubscriptions().subscribe((subs) => {
      this.subscription = subs && subs.length > 0 ? subs[0] : undefined;
      this.hasSubscription = !!subs && subs.length > 0;
    });
  }

  ngOnInit(): void {
    /* This is just a quick fix for stupid problem :) */
    this.classElement = this.document.querySelector(
      '.' + this.classToToggle,
    ) as HTMLElement;
    this.classElement.classList.remove(this.classToToggle);
  }
  ngOnDestroy(): void {
    this.classElement.classList.add(this.classToToggle);
  }

  private getShareUrl(): Observable<string> {
    return this.fnService
      .hashId()
      .pipe(map((id) => `${this.document.location.origin}/login?invite=${id}`));
  }

  copyShareUrl(): void {
    const copyText = this.document.getElementById('copy') as HTMLInputElement;
    copyText.select();
    this.document.execCommand('copy');
    this.shareUrlCopied = true;
    setTimeout(() => (this.shareUrlCopied = false), 1000);
  }
}
